export class ResourceUtil {
    public static resolveUrl(from: string, to: string): string {
        return new URL(to, new URL(from)).toString()
    }
}
